export default __webpack_public_path__ + "static/media/naki-logo.c5c3a5c0.svg";